/**
 * Phase 4: client intent context for BE fuzzy/LLM (Collections selection + last offered intent).
 */
import { readAgentCollectionsSelection } from './agentCollectionsSelection';

export const AGENT_LAST_OFFERED_INTENT_KEY = 'agentLastOfferedIntentId';

export type AgentIntentClientContext = {
  hasSelectedRequest: boolean;
  hasSelectedProject: boolean;
  projectId?: number;
  collectionId?: number;
  requestId?: number;
  environmentId?: number;
  lastOfferedIntentId?: string;
};

export function readLastOfferedAgentIntentId(): string | undefined {
  try {
    const v = sessionStorage.getItem(AGENT_LAST_OFFERED_INTENT_KEY);
    return v?.trim() || undefined;
  } catch {
    return undefined;
  }
}

export function rememberOfferedAgentIntentId(intentId: string | null | undefined): void {
  try {
    if (!intentId || intentId === 'unknown') {
      return;
    }
    sessionStorage.setItem(AGENT_LAST_OFFERED_INTENT_KEY, intentId);
  } catch {
    /* ignore */
  }
}

export function buildAgentIntentClientContext(options?: {
  sessionProjectId?: number | null;
}): AgentIntentClientContext {
  const selection = readAgentCollectionsSelection();
  const sessionProjectId = options?.sessionProjectId ?? null;
  const projectId = selection?.projectId ?? (sessionProjectId != null ? sessionProjectId : undefined);
  return {
    hasSelectedRequest: selection?.requestId != null,
    hasSelectedProject: projectId != null,
    projectId,
    collectionId: selection?.collectionId,
    requestId: selection?.requestId,
    environmentId: selection?.environmentId,
    lastOfferedIntentId: readLastOfferedAgentIntentId(),
  };
}

/** Merge into agentMessage payload so BE can apply context gates (go ahead / proceed / run this). */
export function withAgentIntentContextPayload(
  data?: Record<string, unknown> | null,
  options?: { sessionProjectId?: number | null },
): Record<string, unknown> {
  const base = { ...(data ?? {}) };
  base.intentContext = buildAgentIntentClientContext(options);
  return base;
}

export function isIntentConfirmAction(action: { payload?: Record<string, unknown> } | null | undefined): boolean {
  return Boolean(action?.payload && action.payload.intentConfirm === true);
}
